<template src='./remittanceIntegration.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import RemittanceIntegrationModal from '../../../integration/remittanceIntegration/RemittanceIntegrationModal'
import RemittanceIntegrationCreationModal from '../../../integration/remittanceIntegration/RemittanceIntegrationCreationModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import axios from '../../../../../build/http-requests/axios-common.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import { getArrayOfValues } from '../../../../utils/arrayUtils.js'
import closeModal from '../../../../events/closeModal'

export default {
  name: 'RemittanceIntegration',

  components: {
    vSelect,
    ConfirmModal,
    RemittanceIntegrationModal,
    RemittanceIntegrationCreationModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      remittance: {},
      shown: {
        detail: false,
        new: false
      },
      showGrid: false,
      disableSelect: false,
      gridId: '#RemessasIntegracao',
      firstDate: new Date(),
      finalDate: new Date(),
      result: {},
      treeGridCfg: {},
      filters: {
        origin: 'G',
        remittenceIds: [],
        sequenceNumber: []
      },
      remittenceTypes: [],
      cleanRemittanceTypes: [],
      exportUrl: EXPORT_TREEGRID,
      isExportFile: false,
      disableSearchButton: false,
      arrayRemessas: []
    }
  },

  computed: {
    canRemoveRemittance () {
      return this.$store.getters.allowedFuncionalities && this.$store.getters.allowedFuncionalities.indexOf(4002) >= 0
    },

    disableDateRange () {
      return this.filters.remittenceIds.length > 0 || this.filters.sequenceNumber.length > 0
    }
  },

  methods: {
    getLoadingMessages () {
      return this.isExportFile ? ['geral.loading.andamento', 'geral.loading.preparandoArquivo'] : ['geral.loading.andamento', 'geral.loading.preparandoGrid']
    },

    loadRemittanceTypes () {
      this.$store.dispatch('getRemittanceTypes')
        .then(response => {
          this.remittenceTypes = response.data.data
          this.cleanRemittanceTypes = [...response.data.data]
          this.remittenceTypes.splice(0, 0, { id: 0, nome: this.$t('inputTag.labels.todos') })
          this.filters.type = this.remittenceTypes[0]
          if (this.remittenceTypes.length === 1) {
            this.disableSelect = true
          }
        })
        .catch(() => {
          this.remittenceTypes = []
          this.remittenceTypes.push({ id: 0, nome: this.$t('inputTag.labels.todos') })
          this.filters.type = this.remittenceTypes[0]
          this.disableSelect = true
        })
    },

    newRemittance () {
      this.shown.new = true
    },

    validate () {
      let self = this
      let promise = null
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result && this.$refs.dateRange.validate()) {
            if (self.isExportFile) {
              promise = self.download()
            } else {
              self.showGrid = true
              startTreeGridLoading(self.gridId, self.getLoadingMessages())
              promise = self.search()
            }
            promise.finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    search () {
      if (!this.filters.type) {
        this.filters.type = this.remittenceTypes[0]
      }
      this.disableSearchButton = true
      let filter = {
        inicio: this.filters.period.fromDate,
        fim: this.filters.period.toDate,
        opcaoData: this.filters.origin,
        idCrcMovFinanCfg: this.filters.type.id,
        idsRemessas: getArrayOfValues(this.filters.remittenceIds, 'id'),
        sequencias: getArrayOfValues(this.filters.sequenceNumber, 'id'),
        lang: language.getCookieByName('language'),
        podeExcluirRemessa: this.canRemoveRemittance
      }
      return new Promise((resolve, reject) => {
        this.$store.dispatch('searchRemittanceIntegration', filter)
          .then(response => {
            if (window.Grids[0]) {
              window.DisposeGrids()
            }

            this.treeGridCfg = response.data.Cfg.Layout
            this.result = response.data

            window.Grids.downloadFile = (encodedId, fileName) => {
              axios({
                url: '/remittanceIntegration/download?idMovFin=' + encodedId,
                method: 'GET',
                responseType: 'blob'
              }).then((response) => {
                // cria um link virtual para baixar o arquivo recebido do pipe
                let a = document.createElement('a')
                a.href = window.URL.createObjectURL(new Blob([response.data]))
                a.setAttribute('download', fileName)
                a.click()
                document.body.removeChild(a)
              }).catch((error) => {
                this.$root.$refs.notification.error(error)
                reject()
              })
            }

            window.Grids.abrirModalDetalhes = (idRemittance) => {
              return new Promise((resolve, reject) => {
                this.$store.dispatch('remittanceDetail', idRemittance)
                  .then((response) => {
                    return this.loadDetailModal(response.data)
                  }).catch((error) => {
                    this.$root.$refs.notification.error(error)
                    reject()
                  })
              })
            }

            window.Grids.openAssignmentModal = (row) => {
              this.loadDetailModal(row)
            }

            this.showGrid = true
            this.disableSearchButton = false
            stopTreeGridLoading(this.gridId)
            resolve()
          })
          .catch(error => {
            this.$root.$refs.notification.error(error)
            stopTreeGridLoading(this.gridId)
            this.disableSearchButton = false
            reject()
          })
      })
    },

    loadDetailModal (remittance) {
      this.remittance = remittance
      this.shown.detail = true
    },

    closeDetailModal () {
      this.shown.detail = false
      this.remittance = {}
    },

    loadNewRemittanceModal () {
      this.shown.new = true
    },

    closeNewRemittanceModal () {
      this.shown.new = false
    },

    openModalConfirm () {
      $('#confirmRemittanceRemoval').modal('show')
    },

    closeModalConfirm () {
      $('#confirmRemittanceRemoval').modal('hide')
    },

    removeRemittance () {
      if (this.remittance && this.remittance.id && this.shown.detail) {
        this.arrayRemessas.arrayIdRemessaIntegracao = []
        this.arrayRemessas.arrayLinhaSelecionada = []
        this.arrayRemessas.arrayIdRemessaIntegracao.push(this.remittance.id)
        this.arrayRemessas.arrayLinhaSelecionada.push(this.remittance)
      }
      $('#confirmRemittanceRemoval').modal('hide')
      return new Promise((resolve, reject) => {
        this.$store.dispatch('removeRemittance', this.arrayRemessas.arrayIdRemessaIntegracao)
          .then(response => {
            this.arrayRemessas = []
            this.$root.$refs.notification.success('remessaIntegracao.mensagem.solicitacaoExclusaoSucesso')
            this.closeModalConfirm()
            if (this.shown.detail) {
              this.closeDetailModal()
            }
            resolve()
          })
          .catch(error => {
            this.$root.$refs.notification.error(error)
            reject()
          })
      })
    },

    remittanceRemoval (remessas) {
      if (this.shown.detail) {
        this.closeDetailModal()
      }
      this.arrayRemessas = remessas
      this.openModalConfirm()
    }
  },

  mounted () {
    // Listener para evento de atualização de dados dentro da modal de detalhes,
    // o que requer uma nova consulta para o relatório
    const self = this
    closeModal.$on('modalDetaisClose', (flag) => {
      if (flag) {
        self.showGrid = true
        startTreeGridLoading(self.gridId, self.getLoadingMessages())
        self.search()
        // Altera a flag que recarrega a treegrid após o recarregamento
        // para impedir que ela seja recarregada sempre após a primeira vez
        closeModal.$emit('taskChange', false)
      }
    })
  },

  created () {
    this.loadRemittanceTypes()
  }
}
</script>



// WEBPACK FOOTER //
// RemittanceIntegration.vue?405a2d42